<template>
  <header role="banner" id="fh5co-header">
    <div class="container">
      <nav class="navbar navbar-default">
        <div class="navbar-header">
          <!-- Mobile Toggle Menu Button -->
          <a href="#" class="js-fh5co-nav-toggle fh5co-nav-toggle" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar"><i></i></a>
          <a class="navbar-brand" href="/"><img id="brand-img" src="/images/ebs-cloud-logo.svg" /></a> 
        </div>
        <div id="navbar" class="navbar-collapse collapse">
          <ul class="nav navbar-nav navbar-right">
            <li><a class="external" href="/cloud/index.html"><span>Cloud</span></a></li>
            <li><a class="external" href="/servicos-dedicados/index.html"><span>Serviços Dedicados</span></a></li>
            <li><a class="external" href="/servicos-gerenciados/index.html"><span>Serviços Gerenciados</span></a></li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
  export default {name: 'Header'}
</script>
